import BaseApi from '@/services/base.api.js';

class ModalApi extends BaseApi {
  async sendFeedback(data) {
    let client = await this.getClient();
    return client({
      method: 'POST',
      url: `${this.basicUrl}api/common/feedback`,
      data
    });
  }

  async contactSupport(data) {
    let client = await this.getClient();
    return client({
      method: 'POST',
      url: `${this.basicUrl}api/common/support`,
      data
    });
  }
}

export default ModalApi;
